// import luxy from 'luxy.js';
// if ($("#js-inertiaScroll").length) {
//   luxy.init({
//     wrapper: '#js-inertiaScroll',
//     wrapperSpeed: 0.09
//   });
// }


// console.log($("#js-inertiaScroll").length > 0 ? $("#js-inertiaScroll").css("transform") : "none");